import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { createMilestoneError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  error: createMilestoneError,
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: setRequestStateToPending(),
  };
}

function handleSuccess(state: State): State {
  return {
    ...state,
    request: setRequestStateToSuccess(),
    error: initialState.error,
  };
}

function handleFailure(
  state: State,
  { error }: Boundaries["createMilestone"]["failure"],
): State {
  return {
    ...state,
    error,
    request: setRequestStateToFailure(),
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createMilestoneRequested]: handleRequest,
    [events.createMilestoneSucceeded]: handleSuccess,
    [events.createMilestoneFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
